import React, { useState, useEffect, createRef } from "react";
// 3rd party
import { ref, getDownloadURL, uploadBytes } from "firebase/storage";
import Dropzone from "react-dropzone";
import { useDropzone } from "react-dropzone";
// utils
import getUserClaims from "components/Firebase/FirebaseUserClaimsAssigner/utils/getUserClaims";
import overwriteUserClaims from "components/Firebase/FirebaseUserClaimsAssigner/utils/overwriteUserClaims";
// mui
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import InputBase from "@mui/material/InputBase";
import TextField from "@mui/material/TextField";
import { useTheme } from "@mui/styles";

export default function FirebaseUserClaimsAssigner({ firebaseStorage, user }) {
  const theme = useTheme();

  const [userRecord, setUserRecord] = useState(null);
  const [targetUserUID, setTargetUserUID] = useState(null);
  const [targetUserUIDForClaims, setTargetUserUIDForClaims] = useState(null);
  const [claimsToOverwrite, setClaimsToOverwrite] = useState(null);

  const customUploadResFunction = (input) => {};

  const handleSubmit = (e) => {
    e.preventDefault();
    const file = e.target[0]?.files[0];

    const metadata = {
      customMetadata: {
        // claims: ["appraiser", "title"],
        claims: "appraiser,title",
        // loanID: "1231d12Caw1313",
      },
    };

    if (!file) return null;
    const storageRef = ref(
      firebaseStorage,
      `client_files/loans/${loan.LoanIDCypher}/${file.name}_${randomString(6)}`
    );

    (async () => {
      try {
        const resp = await uploadBytes(storageRef, file, metadata);

        // no longer want to create download url, less secure
        // when direct download after and auth check
        // .then((snapshot) => {
        //   e.target[0].value = "";
        //   getDownloadURL(snapshot.ref).then((downloadURL) => {
        //     console.log(downloadURL);
        //   });
        // });
      } catch (e) {
        console.log("upload bytes error");
        console.log(e);
      }
    })();
  };

  const [progressPercent, setProgressPercent] = useState(0);
  const [files, setFiles] = useState([]);
  const [localUploadingInProgress, setLocalUploadingInProgress] =
    useState(false);

  useEffect(
    () => () => {
      if (files.length > 0) {
        // Make sure to revoke the data uris to avoid memory leaks
        files.forEach((file) => URL.revokeObjectURL(file.preview));
      }
    },
    [files]
  );

  let thumbs = files.map((file) => (
    <Box // used to be Thumb
      key={file.name}
      sx={{
        position: "relative",
        display: "inline-flex",
        // borderRadius: 1px;
        border: "1px solid #eaeaea",
        marginBottom: "8px",
        marginRight: "8px",
        width: "100px",
        height: "100px",
        padding: "4px",
        boxSizing: "border-box",
      }}
    >
      2
      {/* {file.type.includes("pdf") ? (
        <div>
          <GrDocumentPdf size={90} />
        </div>
      ) : (
        <>
          <InnerThumb>
            <InnerImg src={file.preview} />
          </InnerThumb>
        </>
      )}
      {localUploadingInProgress && (
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          style={{
            color: "white",
            position: "absolute",
            top: "40%",
            left: "43%",
          }}
        />
      )} */}
    </Box>
  ));

  const dropzoneRef = createRef();
  const acceptFileTypes = "image/*"; // might expose later
  const maxFilesToAccept = 0; // 0 maxFiles means unlimited, might expose later
  const onDrop = (acceptedFiles) => {
    setFiles(
      acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    );

    setUploadingInProgress(true);
    setLocalUploadingInProgress(true);

    // const formData = new FormData();
    // formData.append("refId", refId);
    // ex: formData.append("refId", pageData.id);
    // formData.append("ref", collection);
    // ex: formData.append("ref", "home-listing");
    // formData.append("field", field);
    // ex: formData.append("field", "Photos");

    thumbs = [];
    // Array.from(acceptedFiles).forEach((image) => {
    //   formData.append("files", image);
    // });

    // const targetUrl = `${process.env.CMS_URL}/upload`;

    return;

    axios
      .post(targetUrl, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((uploadRes) => {
        setUploadingInProgress(false);
        customUploadResFunction(uploadRes);
        setFiles([]);
        setLocalUploadingInProgress(false);

        if (collectionType === "loans") {
          // update log
          if (loan && Object.keys(loan).length > 0) {
            if (uploadRes.data.length > 0) {
              for (let i = 0; i < uploadRes.data.length; i++) {
                const file = uploadRes.data[i];

                for (let j = 0; j < file.related.length; j++) {
                  const related = file.related[j];

                  const logEntry = {
                    // random id generated
                    id: [...Array(30)]
                      .map(() => Math.random().toString(36)[2])
                      .join(""),
                    created_at: new Date(),
                    name: file.name,
                    sectionID: related.__contentType,
                    field: field,
                    url: file.url,
                    status: "unread",
                  };

                  const [localUserLoan] = userLoans.filter((userLoan) => {
                    return userLoan.id === loan.id;
                  });

                  // prefer to use local user loan
                  const uploadLog =
                    Object.keys(localUserLoan).length > 0
                      ? localUserLoan.UploadLog
                      : loan.UploadLog;

                  let updatedLog =
                    uploadLog && uploadLog.length > 0 ? uploadLog.slice() : [];

                  updatedLog.push(logEntry);

                  updatedLog = updatedLog.sort(
                    (a, b) =>
                      Date.parse(new Date(b.created_at)) -
                      Date.parse(new Date(a.created_at))
                  );

                  (async () => {
                    let updatedLoan = await updateLoanUploadLog(
                      user,
                      updatedLog,
                      loan,
                      false
                    );

                    // TODO probably create state for "loan"
                    // so don't have to over load and do this for "userLoans"
                    // "userLoans" should be just IDs that are passed and loanstepper holds loan in state and does stuff
                    let updatedUserLoans = userLoans.slice();

                    let [targetLoan] = updatedUserLoans.filter((userLoan) => {
                      return userLoan.id === updatedLoan.id;
                    });

                    targetLoan.UploadLog = updatedLoan.UploadLog;

                    setUserLoans(updatedUserLoans);
                  })();
                }
              }
            }
          }
        }

        if (collectionType === "insurancePolicies") {
          // TODO in the future when insurance needs upload log
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box>Check Claims</Box>
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Button
            onClick={() => {
              getUserClaims(user, user.uid, setUserRecord);
            }}
            variant="contained"
          >
            {" "}
            Show my claims{" "}
          </Button>
          <TextField
            fullWidth
            sx={{
              height: "100% ",
              "& .MuiOutlinedInput-root": {
                backgroundColor: theme.palette.primary.contrastText,
                height: "100%",
                "& fieldset": {
                  borderColor: theme.palette.primary.main,
                },
              },
            }}
            label={"Target UID"}
            onChange={(e) => {
              setTargetUserUID(e.target.value);
            }}
          />
          <Button
            variant="contained"
            onClick={() => {
              getUserClaims(user, targetUserUID, setUserRecord);
            }}
          >
            Check target user's claims
          </Button>
        </Box>

        <Box>
          {userRecord && (
            <Box>
              <pre>{JSON.stringify(userRecord, null, 2)}</pre>
            </Box>
          )}
        </Box>
      </Box>

      <Box>
        <TextField
          fullWidth
          sx={{
            height: "100% ",
            "& .MuiOutlinedInput-root": {
              backgroundColor: theme.palette.primary.contrastText,
              height: "100%",
              "& fieldset": {
                borderColor: theme.palette.primary.main,
              },
            },
          }}
          label={"Target UID"}
          onChange={(e) => {
            setTargetUserUIDForClaims(e.target.value);
          }}
        />
        <TextField
          fullWidth
          sx={{
            height: "100% ",
            "& .MuiOutlinedInput-root": {
              backgroundColor: theme.palette.primary.contrastText,
              height: "100%",
              "& fieldset": {
                borderColor: theme.palette.primary.main,
              },
            },
          }}
          label={"Claims to overwrite (comma delim)"}
          onChange={(e) => {
            setClaimsToOverwrite(e.target.value);
          }}
        />
        <Button
          variant="contained"
          onClick={() => {
            overwriteUserClaims(
              user,
              targetUserUIDForClaims,
              claimsToOverwrite
            );
          }}
        >
          Add claim
        </Button>
      </Box>
    </Box>
  );
}
